export default {
  meta: {
    title: '角色管理',
    url: '/organization/role', // 埋点用，记录所属模块
    // eventId: '19c54c90-3265-4fcb-a841-d26561846457'
  }
};
